import { KeyboardEvent, useState } from 'react'

import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import Input from 'components/Atoms/Calculator/Input'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

interface SecondStepCompanyProps {
  onCalculate: (employees: number) => void
}

export default function SecondStepCompany({
  onCalculate,
}: SecondStepCompanyProps) {
  const { t } = useTranslation('calculator')
  const [employeesInput, setEmployeesInput] = useState('')

  const handleCalculateClick = () => {
    const parsed = parseInt(employeesInput, 10)
    const employees = Number.isNaN(parsed) ? 0 : parsed
    if (employees <= 0) {
      toast.error(t('calculator.rightColumn.errors.completeAllFields'), {
        theme: 'colored',
      })
      return
    }

    onCalculate(employees)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleCalculateClick()
    }
  }

  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col items-center sm:items-start justify-between md:mt-24 max-sm:gap-6">
        <p>{t('calculator.rightColumn.secondStep.company.text')}</p>
        <Input
          label={t('calculator.rightColumn.secondStep.company.labelInput')}
          placeholder={t(
            'calculator.rightColumn.secondStep.company.placeholder',
          )}
          className="w-48"
          value={employeesInput}
          onChange={setEmployeesInput}
          onKeyDown={handleKeyDown}
        />
        <RoundedButton
          onClick={handleCalculateClick}
          disabled={employeesInput === ''}
        >
          {t('calculator.rightColumn.secondStep.company.cta')}
        </RoundedButton>
      </div>
    </div>
  )
}
